import lensProp from 'ramda/src/lensProp'
import over from 'ramda/src/over'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { ADD_FEATURED_DARE } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default formData => async dispatch => dispatch(
	apiRequest(ADD_FEATURED_DARE, over(lensProp('projectUrl'), decodeURIComponent, formData)),
)
